import { render, staticRenderFns } from "./AreaSelector.vue?vue&type=template&id=1a03f5b4"
import script from "./areaSelector.ts?vue&type=script&lang=js&external"
export * from "./areaSelector.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports